import React, { useEffect, useState } from "react";
import PropertyCard from "./PropertyCard";
import { getAllProperties, getNearbyProperties } from "../../../services/propertyService";

const sortOptions = [
  { label: "Liên quan nhất", value: "relevance" },
  { label: "Ngày đăng: Mới nhất", value: "newest" },
  { label: "Ngày đăng: Cũ nhất", value: "oldest" },
  { label: "Giá: Tăng dần", value: "price-asc" },
  { label: "Giá: Giảm dần", value: "price-desc" },
  { label: "Diện tích: Tăng dần", value: "area-asc" },
  { label: "Diện tích: Giảm dần", value: "area-desc" },
];

export default function PropertyListingArea({ filters, setFilters }) {
  const [properties, setProperties] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortType, setSortType] = useState("relevance");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const data = await getAllProperties(filters, page);
        setProperties(data.properties || []);
        setTotalPages(data.totalPages || 1);
      } catch (error) {
        console.error("Lỗi khi lấy danh sách bất động sản:", error);
        setProperties([]);
      }
    };
    fetchProperties();
  }, [filters, page, sortType]); // ✅ thêm sortType


  const sortedProperties = [...properties].sort((a, b) => {
    switch (sortType) {
      case "price-asc": return a.price - b.price;
      case "price-desc": return b.price - a.price;
      case "area-asc": return a.area - b.area;
      case "area-desc": return b.area - a.area;
      default: return 0;
    }
  });

  // Helper function để tạo mảng số trang với ellipsis
  const getPagination = (current, total) => {
    const delta = 2; // số trang hiển thị xung quanh trang hiện tại
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }

    let last = 0;
    for (let i of range) {
      if (i - last > 1) {
        rangeWithDots.push("...");
      }
      rangeWithDots.push(i);
      last = i;
    }

    return rangeWithDots;
  };

  return (
    <div className="flex-1">
      <div className="flex items-center justify-between mb-4 relative">
        <h2 className="text-xl font-semibold text-blue-900">
          Bất động sản nổi bật – Vinhomes / The Global City
        </h2>

        <div className="text-sm text-blue-600 relative">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="underline focus:outline-none"
          >
            SẮP XẾP: {sortOptions.find((s) => s.value === sortType)?.label}
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-64 bg-white border rounded-xl shadow z-10 p-3 space-y-3">
              {sortOptions.map((option, i) => (
                <label
                  key={i}
                  className="flex items-center gap-2 py-1 cursor-pointer text-sm"
                >
                  <input
                    type="radio"
                    name="sort"
                    value={option.value}
                    checked={sortType === option.value}
                    onChange={() => {
                      setSortType(option.value);
                      setDropdownOpen(false);
                    }}
                    className="accent-blue-600"
                  />
                  {option.label}
                </label>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {sortedProperties.map((property, idx) => (
          <PropertyCard key={idx} property={property} />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex justify-center mt-8 space-x-2">
          <button
            onClick={() => setPage(1)}
            disabled={page === 1}
            className="px-3 py-1 border rounded hover:bg-blue-100 disabled:opacity-50"
          >
            « Đầu
          </button>

          {getPagination(page, totalPages).map((p, idx) =>
            p === "..." ? (
              <span key={idx} className="px-3 py-1 text-gray-400">
                ...
              </span>
            ) : (
              <button
                key={idx}
                onClick={() => setPage(p)}
                className={`px-3 py-1 border rounded ${page === p ? "bg-blue-600 text-white" : "hover:bg-blue-100"}`}
              >
                {p}
              </button>
            )
          )}

          <button
            onClick={() => setPage(totalPages)}
            disabled={page === totalPages}
            className="px-3 py-1 border rounded hover:bg-blue-100 disabled:opacity-50"
          >
            Cuối »
          </button>
        </div>
      )}

    </div>
  );
}
